/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Menu, Button, Dropdown } from 'semantic-ui-react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Constants from '../../config/const';
import * as classes from './classes.module.scss';
import Undo from '../assets/undo';
import ZoomIn from '../assets/zoom_in';
import ZoomOut from '../assets/zoom_out';
import Ruler from '../assets/ruler';
import Save from '../assets/save';
import Info from '../assets/info';
import Export from '../assets/export';
import Silhouette from '../assets/silhouette';
import AddOther from '../assets/add_other';
import NewWall from '../assets/new_wall';
import NewWallPlus from '../assets/new_wall_plus';
import Subtitle from './subtitle';

const renderShopThisWall = (addCurrentWallToCart, works, price, currency) => {
  if (!price) {
    return null;
  }
  return (
    <div>
      <Button
        className={ classes.shop }
        onClick={ addCurrentWallToCart }
        inverted
      >
        ADD TO CART
      </Button>
      <div className={ classes.infoItems }>
        { works.length }
        &nbsp;item(s),
        { currency }
        { price.toFixed(2) }
      </div>
    </div>
  );
};

const CommandBar = ({
  openPanel, zoomIn, zoomOut, resetZoom,
  undo, totalPrice, works, currency,
  addCurrentWallToCart,
  hideSilhouette, setSilhouette,
  hasWorks
}) => {
  const dropDown = (
    <div className={ classes.menuDropDown }>
      <Silhouette fill="#fff" />
      <Subtitle name="Room View" className={ classes.subtitleDropDown } />
    </div>
  );

  const renderCrop = window.canPublish && totalPrice ? (
    <>
      <Menu.Item
        onClick={ () => openPanel({ kind: Constants.panelKinds.customPreview }) }
        className={ classes.menuItem }
      >
        <Export fill="#fff" />
        <Subtitle name="Crop" />
      </Menu.Item>
      <Menu.Item
        onClick={ () => openPanel({ kind: Constants.panelKinds.hanging }) }
        className={ classes.menuItem }
      >
        <Export fill="#fff" />
        <Subtitle name="Hanging" />
      </Menu.Item>
    </>
  ) : null;

  const onSave = () => {
    if (window.isGuest) {
      const sigInLink = document.querySelector('a.signin-link');
      if (sigInLink) {
        const evt = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        sigInLink.dispatchEvent(evt);
      }
      return;
    }
    openPanel({ kind: Constants.panelKinds.export });
  };

  return (
    <Menu inverted className={ classnames(classes.menu, { [classes.noWorks]: !hasWorks }) }>
      <Menu.Item>
        <Button
          className={ classes.add }
          onClick={ () => openPanel({ kind: Constants.panelKinds.works }) }
        >
          <span>+</span>
          Select Art
        </Button>
      </Menu.Item>
      <Menu.Item
        onClick={ () => openPanel({ kind: Constants.panelKinds.other }) }
        className={ classes.menuItem }
      >
        <AddOther fill="#fff" />
        <Subtitle name="Background" />
      </Menu.Item>
      <Menu.Item
        onClick={ () => openPanel({ kind: Constants.panelKinds.grids }) }
        className={ classes.menuItem }
      >
        <Ruler fill="#fff" />
        <Subtitle name="Rulers and Grid" />
      </Menu.Item>
      <Dropdown additionLabel="simple" item icon={ dropDown }>
        <Dropdown.Menu>
          <Dropdown.Item
            className={ classes.silhouetteOption }
            onClick={ () => setSilhouette('livingRoom') }
          >
            <img src={ Constants.silhouette.mappingSmall.livingRoom } alt="Living Room" />
            Living Room
          </Dropdown.Item>
          <Dropdown.Item className={ classes.silhouetteOption } onClick={ () => setSilhouette('chaise') }>
            <img src={ Constants.silhouette.mappingSmall.chaise } alt="Chaise" />
            Chaise
          </Dropdown.Item>
          <Dropdown.Item className={ classes.silhouetteOption } onClick={ () => setSilhouette('console') }>
            <img src={ Constants.silhouette.mappingSmall.console } alt="Console" />
            Console
          </Dropdown.Item>
          <Dropdown.Item onClick={ hideSilhouette }>
            Hide
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <Menu.Item className={ classes.menuItem }>
        <div className={ classes.zoomHolder }>
          <ZoomOut fill="#fff" onClick={ zoomOut } className={ classes.zoom } />
          <ZoomIn fill="#fff" onClick={ zoomIn } className={ classes.zoom } />
        </div>
        <Subtitle name="Zoom" />
      </Menu.Item>
      <Menu.Item onClick={ resetZoom } className={ classes.reset }>
        Reset Zoom
      </Menu.Item>
      <Menu.Menu position="right" className={ classes.rightMenu }>
        <div className={ classes.divider } />
        <Menu.Item
          onClick={ undo }
          className={ classes.menuItem }
        >
          <Undo fill="#fff" />
          <Subtitle name="Undo" />
        </Menu.Item>
        <div className={ classes.divider } />
        <Menu.Item
          className={ classes.menuItem }
          onClick={ () => { window.location.href = '/stylist/wall_builder/new'; } }
        >
          <NewWallPlus fill="#fff" />
          <Subtitle name="New Wall" />
        </Menu.Item>
        <div className={ classes.divider } />
        <Menu.Item
          className={ classes.menuItem }
          onClick={ () => { window.location.href = `/stylist/wall_builder/new?source_wall_id=${ window.wall.wallId }`; } }
        >
          <NewWall fill="#fff" />
          <Subtitle name="Duplicate" />
        </Menu.Item>
        <div className={ classes.divider } />
        <Menu.Item
          className={ classes.menuItem }
          onClick={ onSave }
        >
          <Save fill="#fff" />
          <Subtitle name="Save &amp; Share" />
        </Menu.Item>
        <div className={ classnames(classes.divider, classes.full) } />
        { renderCrop }
        <div className={ classnames(classes.divider, classes.full) } />
        <Menu.Item
          onClick={ () => openPanel({ kind: Constants.panelKinds.info }) }
          className={ classes.menuItem }
        >
          <Info fill="#fff" />
          <Subtitle name="Art Info" />
        </Menu.Item>
        <div className={ classnames(classes.divider, classes.full) } />
        <Menu.Item>
          { renderShopThisWall(addCurrentWallToCart, works, totalPrice, currency) }
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  );
};

CommandBar.propTypes = {
  openPanel: PropTypes.func.isRequired,
  zoomIn: PropTypes.func.isRequired,
  zoomOut: PropTypes.func.isRequired,
  resetZoom: PropTypes.func.isRequired,
  addCurrentWallToCart : PropTypes.func.isRequired,
  hideSilhouette: PropTypes.func.isRequired,
  setSilhouette: PropTypes.func.isRequired,
  undo: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  detailsVisible: PropTypes.bool.isRequired,
  works: PropTypes.array.isRequired,
  totalPrice: PropTypes.number.isRequired,
  hasWorks: PropTypes.bool.isRequired
};

export default CommandBar;
